import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgNoMakeupGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.638 13.848 38 8.819 37.057 8l-5.074 5.848h-.26v-2.34h2.044v-1.25H28.43v1.25h2.044v2.34h-3.5v1.25h3.5v.49l-1.497 1.724h-2.003v1.25h.919l-6.38 7.35v-5.377h-7.037v13.488L10 39.18l.944.82 3.531-4.07v1.185h7.038V27.82l8.034-9.258h.926v2.586h-2.044v1.25h2.044v5.56h1.25v-5.56h2.044v-1.25h-2.044v-2.586h3.5v-1.25h-3.5v-1.258l.83-.956h2.67v-1.25h-1.585ZM20.057 27.59v-5.447h-4.125v10.2l4.125-4.753Zm-4.125 6.66 4.125-4.753v6.132h-4.125v-1.378Zm17.229 1.38v-6.063h-4.004v6.062h4.004Zm-5.582-7.672h7.038v9.156h-7.038V27.96Z",
    fill: "currentColor"
  }));
}

export { SvgNoMakeupGlyph as default };
